import { ReactNode } from 'react';

import { ModalProps } from '@mui/material';
import create from 'zustand';

export interface ModalStore {
  show: boolean;
  title: string;
  component: ReactNode | null;
  modalProps?: Partial<ModalProps>;
  className?: string;
  type?: 'drawer' | 'dialog';
  withHeader?: boolean;
}

export interface ModalState extends ModalStore {
  openModal: (_modal: Omit<ModalStore, 'show'>) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  show: false,
  title: '',
  component: null,
  openModal: (modal: Omit<ModalStore, 'show'>) =>
    set({
      ...modal,
      show: true,
    }),
  closeModal: () =>
    set({
      show: false,
      title: '',
      component: null,
    }),
}));
